module.exports = __webpack_public_path__ + "static/media/9.1d6a2b16.jpg";